module.exports = __webpack_public_path__ + "static/thumbnail-996d3e524572f7388e78b995d019c20c.png";